import { lazy } from 'react';

export { default as routes } from './routes';

export const Events = lazy(() => import('./pages/Events'));

export { default as EventOverview } from './pages/EventOverview';
export { default as EventDetails } from './pages/EventDetails/EventDetails';
export { default as useEventParticpantColumns } from './hooks/use-event-participant-columns';
